<script lang="ts">
  import Button, { button } from '$components/ui/button.svelte';
  import { cn } from '$lib/utils';
  import { getAnchorFromCmsLink } from '$lib/utils/cms';
  import type { ButtonCtaStoryblok } from '$types/bloks';
  import type { VariantProps } from 'class-variance-authority';

  export let block: ButtonCtaStoryblok;
  export let variant: VariantProps<typeof button>['variant'] | undefined = 'ghost';

  let className: string | undefined = undefined;
  export { className as class };
</script>

{#if block}
  {@const { href, rel, target } = $getAnchorFromCmsLink(block.link)}
  <Button
    name={block.label}
    as="a"
    size="sm"
    class={cn('rich-text-button-cta', block.full_width && 'w-full', className)}
    {variant}
    {href}
    {rel}
    {target}
  >
    {block.label}
  </Button>
{/if}
